import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'
import store from '@/store'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const currentUser = store.getters['authorization/getCurrentUser']

  const hrAccess = Object.entries(currentUser).length > 0
    ? currentUser.role_accesses.some(item => item.entity === 'Hr_system')
    : false

  const isRecruiter = Object.entries(currentUser).length > 0
    ? currentUser.roles.some(role => role.id === 14)
    : false

  store.commit('authorization/SET_LASTROUTE', from.fullPath)

  if (to.meta.auth) {
    if (!store.getters['authorization/isAuth']) {
      next({ name: "Login" })
    } else if (to.path.includes('/hr') && !hrAccess && !isRecruiter) {
      next({ name: "dashboard" })
    } else {
      next()
    }
  } else if (to.name === "Login" && store.getters['authorization/isAuth']) {
    next()
  } else {
    next()
  }
})

export default router
